import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';

export const fetchRequestAutoComplete = (searchText: string) =>
  requestReactQuery<any>({
    url: routeReplacer(PROVIDER_SERVICE_URLS.GET_PLACES_AUTO_COMPLETE, {
      input: searchText,
      languageCode: 'en',
    }),
    config: { method: 'GET' },
  });

export const fetchRequestDetails = (searchText: string) =>
  searchText?.length
    ? requestReactQuery<any>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.GET_PLACES_DETAILS, {
          place: searchText,
          languageCode: 'en',
        }),
        config: { method: 'GET' },
      })
    : {
        latitude: null,
        longitude: null,
      };

export const areCoordinatesClose = (
  latitude: number,
  longitude: number,
  newLatitude: number,
  newLongitude: number,
  toleranceInMeters: number = 10,
) => {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const R = 6371000; // Earth's radius in meters

  const dLat = toRad(newLatitude - latitude);
  const dLon = toRad(newLongitude - longitude);

  const lat1Rad = toRad(latitude);
  const lat2Rad = toRad(newLatitude);

  const a =
    Math.sin(dLat / 2) ** 2 + Math.sin(dLon / 2) ** 2 * Math.cos(lat1Rad) * Math.cos(lat2Rad);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = Number(Number(R * c).toFixed(2));

  return { isNearBy: distance <= toleranceInMeters, distance };
};

export const getLegecyCoordinatesFromAddress = async (address: string) =>
  new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results: any, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        const { lat, lng } = results[0].geometry.location;
        const latitude = lat();
        const longitude = lng();
        resolve({ latitude, longitude });
      } else {
        reject({ latitude: null, longitude: null });
      }
    });
  });
